// Projects API
import { api } from './client';

export const projectsAPI = {
  getAll: () => {
    console.log('📁 Fetching all projects');
    return api.get('/projects');
  },
  getById: (id: number) => {
    console.log('📁 Fetching project:', id);
    return api.get(`/projects/${id}`);
  },
  create: (data: any) => {
    console.log('➕ Creating new project:', data.name);
    return api.post('/projects', data);
  },
  update: (id: number, data: any) => {
    console.log('📝 Updating project:', id, data);
    return api.put(`/projects/${id}`, data);
  },
  delete: (id: number) => {
    console.log('🗑️ Deleting project:', id);
    return api.delete(`/projects/${id}`);
  },
  // Project owner management (admin only)
  getOwner: (id: number) => {
    console.log('👤 Fetching project owner:', id);
    return api.get(`/projects/${id}/owner`);
  },
  setOwner: (id: number, ownerId: number | null) => {
    console.log('👤 Setting project owner:', id, 'to user:', ownerId);
    return api.put(`/projects/${id}/owner`, { owner_id: ownerId });
  },
  // Vulnerability evolution over time
  getVulnerabilityEvolution: (id: number) => {
    console.log('📊 Fetching vulnerability evolution for project:', id);
    return api.get(`/projects/${id}/vulnerability-evolution`);
  },
};
